import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import {
  ProductsState,
  ProductsApiResponse,
  ProductsHighlightedApiResponse,
  ProductsContinuationApiResponse,
  ProductDetailsApiResponse,
  ProductsMyApiResponse,
  ProductsCompletedApiResponse,
  ProductsTeachersApiResponse,
  ProductEvolutionDetailsApiResponse,
  AvailableClassesApiResponse,
  ProgramsApiResponse,
} from '../types';

const initialState: ProductsState = {
  products: [],
  productsHighlighted: [],
  productsMy: [],
  productsTeachers: [],
  productsCompleted: [],
  productsContinuation: undefined!,
  productsModules: [],
  productDetails: undefined!,
  productEvolutionDetails: undefined!,
  availableClasses: undefined!,
  programs: [],
  programsMy: [],
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProductsAction(state, action: PayloadAction<ProductsApiResponse>) {
      state.products = [...action.payload.courses];
      state.totalPages = action.payload.totalPages;
    },

    clearProductsAction(state) {
      state.products = [];
      state.totalPages = undefined;
    },

    setAvailableClassesAction(state, action: PayloadAction<AvailableClassesApiResponse>) {
      state.availableClasses = action.payload;
    },

    clearAvailableClassesAction(state) {
      state.availableClasses = undefined!;
    },

    setProductsHighlightedAction(state, action: PayloadAction<ProductsHighlightedApiResponse>) {
      state.productsHighlighted = [...action.payload.courses];
    },

    clearProductsHighlightedAction(state) {
      state.productsHighlighted = [];
    },

    setProductsMyAction(state, action: PayloadAction<ProductsMyApiResponse>) {
      state.productsMy = action.payload.courses;
    },

    clearProductsMyAction(state) {
      state.productsMy = [];
    },

    setProductsCompletedAction(state, action: PayloadAction<ProductsCompletedApiResponse>) {
      state.productsCompleted = action.payload.courses;
    },

    clearProductsCompletedAction(state) {
      state.productsCompleted = [];
    },

    setProductsContinuationAction(state, action: PayloadAction<ProductsContinuationApiResponse>) {
      state.productsContinuation = action.payload;
    },

    clearProductsContinuationAction(state) {
      state.productsContinuation = undefined!;
    },

    setProductDetailsAction(state, action: PayloadAction<ProductDetailsApiResponse>) {
      state.productDetails = action.payload;
    },

    clearProductDetailsAction(state) {
      state.productDetails = undefined!;
    },

    setProductsTeachersAction(state, action: PayloadAction<ProductsTeachersApiResponse>) {
      state.productsTeachers = action.payload.courses;
    },

    clearProductsTeachersAction(state) {
      state.productsTeachers = [];
    },

    setProductEvolutionDetailsAction(state, action: PayloadAction<ProductEvolutionDetailsApiResponse>) {
      state.productEvolutionDetails = action.payload;
    },

    clearProductEvolutionDetailsAction(state) {
      state.productEvolutionDetails = undefined!;
    },

    setProgramsAction(state, action: PayloadAction<ProgramsApiResponse>) {
      state.programs = [...action.payload.programs];
    },

    clearProgramsAction(state) {
      state.programs = [];
    },

    setProgramsMyAction(state, action: PayloadAction<ProgramsApiResponse>) {
      state.programsMy = [...action.payload.programs];
    },

    clearProgramsMyAction(state) {
      state.programsMy = [];
    },
  },
});

export const {
  setProductsAction,
  clearProductsAction,

  setProductsHighlightedAction,
  clearProductsHighlightedAction,

  setProductsMyAction,
  clearProductsMyAction,

  setProductsCompletedAction,
  clearProductsCompletedAction,

  setProductsContinuationAction,
  clearProductsContinuationAction,

  setProductDetailsAction,
  clearProductDetailsAction,

  setProductsTeachersAction,
  clearProductsTeachersAction,

  setProductEvolutionDetailsAction,
  clearProductEvolutionDetailsAction,

  setAvailableClassesAction,
  clearAvailableClassesAction,

  setProgramsAction,
  clearProgramsAction,

  setProgramsMyAction,
  clearProgramsMyAction,
} = productsSlice.actions;

export const getProducts = (state: RootState): ProductsState => state.products;

export default productsSlice.reducer;
